import React from "react";
import PropTypes from "prop-types";
import { Row, Spin, Icon } from "antd";
import { get } from "lodash";
import { Lib, CheckPermission } from "App/Utils";
import SubAllList from "App/Component/SubAllList";
import descriptor from "./descriptorOffline";

class PageProduct extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isGettingPermissions: true,
      permissionItems: [],
    }
  }

  getPermissions = () => {
    const permissionItems = CheckPermission.getPermissionSet({
      userReducer: this.props.userReducer,
      appName: 'estimation',
      modelName: 'product',
    }).filter(perm => !perm.includes('.delete_'))
    this.setState({ isGettingPermissions: false, permissionItems })
  }

  onAddProduct = () => {
    const { productGroup } = this.props
    this.props.history.push(
      '/product/product/add',
      {
        from: [this.props.location.pathname],
        dataIdentifier: {
          groups: [{ pk: productGroup.pk, name: productGroup.name }]
        },
      }
    )
  }

  onDetailProduct = (id) => {
    this.props.history.push(`/product/product/${id}`, { from: [this.props.location.pathname] })
  }

  componentDidMount() {
    this.getPermissions()
  }

  componentWillUnmount() {
    Lib.windowStop();
  }

  render() {
    const { userReducer, match } = this.props
    const { isGettingPermissions, permissionItems } = this.state

    return isGettingPermissions ? (
      <Row type='flex' justify='center' align='middle' style={{ margin: '30vh 0' }}>
        <Spin
          size='large'
          tip='Loading...'
          indicator={<Icon spin type='loading' style={{ fontSize: '4rem' }} />}
        />
      </Row>
    ) : (
      <SubAllList
        permissions={permissionItems}
        pageTitle="Product"
        avatar="name"
        descriptor={descriptor}
        masterKey="module-product-productGroup-refProduct"
        args={[get(match, 'params.id')]}
        onAddClick={this.onAddProduct}
        onDetailClick={this.onDetailProduct}
        userReducer={userReducer}
        operation={false}
      />
    );
  }
}

PageProduct.propTypes = {
  userReducer: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  productGroup: PropTypes.object.isRequired,
}

PageProduct.defaultProps = {
  permissionItems: [],
}

export default PageProduct;
